<template>
  <div>
    <list-table
      ref="users_table_ref"
      :records="contributions" 
      :columns="tableColumns"
      :total-records="contributions.length"
      :current-page-number="1"
      :show-search="false"
      :show-export-button="false"
      :show-import-button="false"
    >
      <template #cell(status)="data">
        <b-badge
          pill
          :variant="`light-${resolveStatusVariant(data.item.status)}`"
          class="text-capitalize"
        >
          {{ getUserStatusText(data.item.status) }}
        </b-badge>
      </template>
    </list-table>
  </div>
</template>

<script>
import {
  BOverlay, BCard, BRow, BCol, BAlert, BLink, BTable,
  BMedia, BAvatar, BButton, BFormFile,
  BBadge, BDropdown, BDropdownItem, BPagination,
  BInputGroup, BInputGroupAppend, BFormInput
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

import ListTable from "@/@core/components/ListTable/ListTable.vue";

export default {
  components: {
    ListTable,

    BOverlay,
    BCard,
    BTable,
    BRow,
    BCol,
    BAlert,
    BBadge,
    BLink,
    BMedia,
    BAvatar,
    BDropdown,
    BDropdownItem,
    BPagination,
    BButton,
    BFormFile,
    BInputGroup, 
    BInputGroupAppend, 
    BFormInput,

    vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    contributions: {
      type: Array,
      required: true
    },
  },
  data(){
    return {
      tableColumns: [
        { key: 'amount', sortable: false, label: 'Amount', formatter: val => `${this.formatMoney(val)}` },
        { key: 'payment_date', sortable: false, formatter: val => `${this.formatDate(val)}` },
        { key: 'next_renewal_date', label: 'Renewal', sortable: false, formatter: val => `${this.formatDate(val)}` },
        { key: 'financial_transaction_id', label: 'Ref', sortable: false },
        { key: 'status', label: 'Status', sortable: false },
      ],
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@core/scss/vue/libs/vue-select.scss';
  .width-100 {
    width: 100px;
  }
  .per-page-selector {
    width: 90px;
  }
</style>

<style lang="scss">
  .loan-list-tb-row {
    cursor: pointer !important;
  }
</style>
